var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "new-zoho-channel-form" } },
    [
      _c("a-form", [
        _c("div", { staticClass: "form-wrapper" }, [
          _c(
            "div",
            { staticClass: "input-wrapper d-none" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("whatsappChannel.channelName"))),
              ]),
              _vm._v(" "),
              _c(
                "a-form-item",
                {
                  attrs: {
                    "validate-status": _vm.getErrorStatus("channelName"),
                    help: _vm.getErrorMessage("channelName"),
                  },
                },
                [
                  _c("a-input", {
                    ref: "channelName",
                    attrs: {
                      placeholder: _vm.$t("whatsappChannel.channelName"),
                      name: "channelName",
                    },
                    model: {
                      value: _vm.form.channelName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "channelName", $$v)
                      },
                      expression: "form.channelName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "input-wrapper" }, [
            _c("label", [_vm._v("Zoho Account URL")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "zoho-account-urls" },
              _vm._l(_vm.zohoAccountUrls, function (url) {
                return _c(
                  "div",
                  {
                    key: url.value,
                    staticClass: "zoho-account-url",
                    class: { selected: _vm.form.accountUrl === url.value },
                    on: {
                      click: function ($event) {
                        _vm.form.accountUrl = url.value
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "region" }, [
                      _vm._v(_vm._s(url.label)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "url" }, [
                      _vm._v(_vm._s(url.value)),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c("a-button", { on: { click: _vm.handleCancel } }, [
              _vm._v(_vm._s(_vm.$t("message.cancel"))),
            ]),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticClass: "pr-confirm-btn",
                attrs: { type: "primary", disabled: _vm.loading },
                on: { click: _vm.handleSubmit },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("mail.connect")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }